import React, { createContext, useContext } from "react";
import {
  Dialog,
  DialogType,
  DialogFooter,
} from "@fluentui/react/lib/Dialog";
import { DatePicker, notification, Modal } from "antd";
import TargetStore from "../productiontarget/store/TargetStore";
import Form from "antd/lib/form/Form";
import { Formik } from "formik";
import moment from "moment";
import FormItem from "antd/lib/form/FormItem";
import { Observer, observer } from "mobx-react-lite";
import CommercialStore from "../settings/store/CommercialStore";
import { toAntPickerDate } from "../../Utility/modules/datePicker";

import { ProgressIndicator } from "@fluentui/react";

const commercialStoreCtx = createContext(CommercialStore);
const targetstore = createContext(TargetStore);
export const ContractRollover = observer(() => {
  const commercialStore = useContext(commercialStoreCtx);
  const targetStore = useContext(targetstore);
  return (
    <Modal
      visible={commercialStore.showRolloverDialog}
      onCancel={() => {
        commercialStore.showRolloverDialog = false;
      }}
      centered
      minWidth={400}
      title={"Rollover Contract Obligations"}
      okText={"Copy"}
      onOk={async () => {
        if (commercialStore.contractYear <= commercialStore.rolloverYear) {
          notification.error({
            key: "error",
            message: "SPARS Feedback",
            description:
              "select past/previous year to rollover contract obligations from",
          });
          return false;
        }

        await commercialStore.copy(targetStore.mainStore.assetContextId);
        commercialStore.showRolloverDialog = false;
        commercialStore.disableSave = false;
      }}
    >
      <Formik>
        {({
          values,
          errors,
          touched,
          handleChange,

          handleSubmit,
          isSubmitting,
        }) => (
          <Form layout="vertical">
            <FormItem label="Rollover from" required>
              <DatePicker
                picker="year"
                defaultValue={toAntPickerDate(`01-01-${moment(new Date()).year() - 1}`, "MM-DD-YYYY")}
                allowClear={false}
                format={"YYYY"}
                onChange={async (date, dateString) => {
                  try {
                    commercialStore.rolloverYear = Number(dateString);
                  } catch (error) {
                    notification.error({
                      key: "error",
                      message: "SPARS Feedback",
                      description: error.message,
                    });
                  }
                }}
              />
            </FormItem>
            <FormItem>
              <Observer>
                {() => (
                  <>
                    {commercialStore.isCopying && (
                      <ProgressIndicator
                        description="processing,please wait..."
                        styles={{
                          root: {
                            textAlign: "center",
                            marginRight: "50px",
                          },
                        }}
                      ></ProgressIndicator>
                    )}
                  </>
                )}
              </Observer>
            </FormItem>
          </Form>
        )}
      </Formik>
    </Modal>
  );
});

